import React from "react";

export const ConseilIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.37752 3.08241C8.9407e-08 3.62028 0 5.21907 0 8.4167V9.9914C0 15.6294 4.23896 18.3655 6.89856 19.5273C7.62 19.8424 7.9807 20 9 20C10.0193 20 10.38 19.8424 11.1014 19.5273C13.761 18.3655 18 15.6294 18 9.9914V8.4167C18 5.21907 18 3.62028 17.6225 3.08241C17.245 2.54454 15.7417 2.02996 12.7351 1.00079L12.1623 0.80472C10.595 0.26824 9.8114 0 9 0C8.1886 0 7.405 0.26824 5.83772 0.80472L5.26491 1.00079C2.25832 2.02996 0.75503 2.54454 0.37752 3.08241ZM12.0595 8.4995C12.3353 8.1905 12.3085 7.71642 11.9995 7.44055C11.6905 7.16467 11.2164 7.19151 10.9405 7.50049L7.9286 10.8739L7.0595 9.9005C6.78358 9.5915 6.30947 9.5647 6.00049 9.8405C5.69151 10.1164 5.66467 10.5905 5.94055 10.8995L7.3691 12.4995C7.5114 12.6589 7.7149 12.75 7.9286 12.75C8.1422 12.75 8.3457 12.6589 8.488 12.4995L12.0595 8.4995Z"
          fill="#E0E0E0"
        />
      </svg>
    </div>
  );
};
